import React, { forwardRef, useEffect, useState } from 'react';
import {
	type ButtonProps,
	Button as FriskButton,
} from '@hdir/ui/button';


export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ disabled, ...otherProps }, ref) => {
	const [hydrated, setHydrated] = useState(false);

	useEffect(() => {
		setHydrated(true);
	}, []);

	return (
		<FriskButton {...otherProps} disabled={!hydrated || disabled} ref={ref}/>
	);
});
